<div class="contact-card-box">
  <div class="contact-header">
    <img
      class="contact-header-icon"
      libSrc="/assets/icons/contact-header-s-icon.png"
      alt="contact-header-icon"
    />
    <img
      class="contact-header-icon center-header-icon"
      libSrc="/assets/icons/contact-header-o-icon.png"
      alt="contact-header-icon"
    />
    <img
      class="contact-header-icon"
      libSrc="/assets/icons/contact-header-s-icon.png"
      alt="contact-header-icon"
    />
  </div>

  <div class="contact-contents">
    <dl class="contact-info-list">
      <dd class="contact-info-item">
        <p class="contact-info-label">CONTACT</p>

        <img
          class="contact-arrow-icon"
          libSrc="/assets/icons/contact-arrow-sm-icon.png"
          alt="contact-arrow-icon"
        />

        <div class="contact-info-box">
          <p class="contact-info">+82 10.8811.8991</p>
          <p class="contact-info">ososo_0@naver.com</p>
        </div>
      </dd>

      <dd class="contact-info-item">
        <p class="contact-info-label">OFFICE</p>

        <img
          class="contact-arrow-icon"
          libSrc="/assets/icons/contact-arrow-sm-icon.png"
          alt="contact-arrow-icon"
        />

        <div class="contact-info-box">
          <p class="contact-info margin-bottom__other">
            제주특별자치도 제주시 탑동로 31, 3F
          </p>

          <p class="contact-info">
            <span class="transform-text-box">
              M<span class="transform-text">O</span>N
            </span>
            - FRI 9:00-18:00
          </p>
        </div>
      </dd>
    </dl>
  </div>

  <div class="contact-bottom">
    <img
      class="contact-bottom-icon"
      libSrc="/assets/icons/contact-bottom-icon.png"
      alt="contact-bottom-icon"
    />

    <a class="contact-download-link" (click)="download()">Download Portfolio</a>
  </div>
</div>
